/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import { JSONMap as r } from "../../core/jsonMap.js";
import { JSONSupport as t } from "../../core/JSONSupport.js";
import { property as o } from "../../core/accessorSupport/decorators/property.js";
import "../../core/accessorSupport/ensureType.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import { subclass as s } from "../../core/accessorSupport/decorators/subclass.js";
var i;
const n = new r({
  slider: "slider",
  picker: "picker"
});
let p = i = class extends t {
  constructor(e) {
    super(e), this.interactionMode = null, this.numStops = null, this.stopInterval = null;
  }
  clone() {
    return new i({
      interactionMode: this.interactionMode,
      numStops: this.numStops,
      stopInterval: this.stopInterval
    });
  }
};
e([o({
  type: n.apiValues,
  nonNullable: !0,
  json: {
    type: n.jsonValues,
    default: null,
    read: {
      reader: n.read
    },
    write: {
      isRequired: !0,
      writer: n.write
    }
  }
})], p.prototype, "interactionMode", void 0), e([o({
  type: Number,
  json: {
    read: {
      source: "numberOfStops"
    },
    write: {
      target: "numberOfStops",
      overridePolicy() {
        const e = null != this.stopInterval;
        return {
          enabled: !e,
          isRequired: !e
        };
      }
    }
  }
})], p.prototype, "numStops", void 0), e([o({
  type: Number,
  json: {
    write: {
      overridePolicy() {
        return {
          isRequired: null == this.numStops
        };
      }
    }
  }
})], p.prototype, "stopInterval", void 0), p = i = e([s("esri.webdoc.widgets.Range")], p);
const a = p;
export { a as default };